import { FormsService } from "../../../services/forms/forms.service";

import { ChangeLimitSettingsActionType } from "../types";
import { getChangedFormLimitsSettings } from "../../../helpers/dataManipulations";

export function* changeLimitsSettingsSaga({ payload }: ChangeLimitSettingsActionType) {
    try {
        yield FormsService.newUpdateForm({
            data: getChangedFormLimitsSettings(payload.prevState, payload.currentState),
        });
    } catch (error) {
        // yield put(Handle Error);
    }
}
